export type GetSubscriptionState = {
    getSubscriptionLinkLoading: boolean;
    getSubscriptionLinkSuccess: boolean;
    subscriptionUrl: string;
    errorCode: string;
    hasData: boolean;

    getPartNumberLoading: boolean;
    getPartNumberSuccess: boolean;
    loading: boolean;
    success: boolean;

    entitlementLoading: boolean;
    entitlementSuccess: boolean;

    mappingLoading: boolean;
    mappingSuccess: boolean;
    subscriptionType: string;
    quantity: number;
    expirationDate: string | null;
    partNumberData: any;
};
export const initialGetSubscriptionState: GetSubscriptionState = {
    getSubscriptionLinkLoading: false,
    getSubscriptionLinkSuccess: false,
    subscriptionUrl: '',
    errorCode: '',
    hasData: true,

    getPartNumberLoading: false,
    getPartNumberSuccess: false,
    loading: false,
    success: false,

    entitlementLoading: false,
    entitlementSuccess: false,

    mappingLoading: false,
    mappingSuccess: false,
    subscriptionType: '',
    quantity: 0,
    expirationDate: '',
    partNumberData: {}
};
